module.exports = __webpack_public_path__ + "static/media/order-icon.a2da98c3.webp";